/* Bagzia storefront interactions */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Sticky header shadow ---------- */
  var header = $('.bz-header');
  if (header) {
    var scroller = document.querySelector('.page-wrapper');
    var onScroll = function () {
      var y = Math.max(window.scrollY, scroller ? scroller.scrollTop : 0);
      header.classList.toggle('is-scrolled', y > 44);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    if (scroller) scroller.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Drawers (menu, filters) ---------- */
  function openDrawer(el) {
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bz-lock');
    var f = el.querySelector('button, a, input');
    if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bz-lock');
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-bz-open]');
    if (o) { e.preventDefault(); openDrawer(document.getElementById(o.getAttribute('data-bz-open'))); return; }
    var c = e.target.closest('[data-bz-close]');
    if (c) { e.preventDefault(); closeDrawer(c.closest('.bz-drawer, .bz-filters-wrap')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('.bz-drawer.is-open, .bz-filters-wrap.is-open').forEach(closeDrawer);
  });

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(html) {
    var t = $('#bz-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'bz-toast';
      t.className = 'bz-toast';
      t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9.5"/><path d="m8 12.3 2.8 2.8L16.3 9.6"/></svg><span>' + html + '</span>';
    requestAnimationFrame(function () { t.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 4200);
  }

  /* ---------- Cart ---------- */
  function refreshCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-bz-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.setAttribute('data-count', cart.item_count);
        });
        return cart;
      })
      .catch(function () {});
  }

  function ajaxAdd(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Sorry, this item could not be added.');
        return j;
      });
    });
  }

  function themeDrawer() { return document.querySelector('theme-drawer#cart-drawer'); }

  function addToCart(id, qty, opts) {
    qty = Math.max(1, parseInt(qty, 10) || 1);
    opts = opts || {};
    var actions = window.Shopify && window.Shopify.actions;
    var useDrawer = !opts.silent && actions && actions.updateCart && themeDrawer();
    var p;
    if (useDrawer) {
      p = Promise.resolve()
        .then(function () { return actions.updateCart({ lines: [{ merchandiseId: String(id), quantity: qty }] }); })
        .then(function (res) {
          if (res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message);
          setTimeout(function () {
            var d = themeDrawer();
            if (d && !d.hasAttribute('open') && actions.openCart) { try { actions.openCart(); } catch (e) {} }
          }, 350);
          return 'drawer';
        })
        .catch(function (err) {
          // Fall back to the classic AJAX cart if the theme actions are unavailable
          if (err && err.message && /stock|available|quantity/i.test(err.message)) throw err;
          return ajaxAdd(id, qty).then(function () { return 'ajax'; });
        });
    } else {
      p = ajaxAdd(id, qty).then(function () { return 'ajax'; });
    }
    return p.then(function (mode) {
      refreshCount();
      if (mode === 'ajax' && !opts.silent) {
        toast((opts.title ? '<b>' + opts.title + '</b> added to your cart.' : 'Added to your cart.') + ' <a href="/cart">View cart</a>');
      }
      return mode;
    });
  }

  function setLoading(btn, on) {
    if (!btn) return;
    btn.classList.toggle('is-loading', on);
    if (on) btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy');
  }
  function flashAdded(btn) {
    if (!btn) return;
    var label = btn.getAttribute('data-label') || btn.innerHTML;
    btn.setAttribute('data-label', label);
    btn.classList.add('is-added');
    btn.innerHTML = 'Added ✓';
    setTimeout(function () { btn.classList.remove('is-added'); btn.innerHTML = label; }, 1800);
  }
  function showError(btn, msg) {
    var form = btn && btn.closest('form');
    var box = form && form.querySelector('[data-bz-error]');
    if (box) { box.textContent = msg; box.hidden = false; } else { toast(msg); }
  }

  window.Bagzia = { addToCart: addToCart, refreshCount: refreshCount, toast: toast };

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-bz-add]');
    if (add) {
      e.preventDefault();
      setLoading(add, true);
      addToCart(add.getAttribute('data-bz-add'), 1, { title: add.getAttribute('data-bz-title') })
        .then(function () { flashAdded(add); })
        .catch(function (err) { showError(add, err.message); })
        .finally(function () { setLoading(add, false); });
      return;
    }
    var buy = e.target.closest('[data-bz-buy-now]');
    if (buy) {
      e.preventDefault();
      var id = buy.getAttribute('data-bz-buy-now');
      var qtyInput = buy.getAttribute('data-bz-qty-from') ? document.querySelector(buy.getAttribute('data-bz-qty-from')) : null;
      var qty = qtyInput ? qtyInput.value : 1;
      setLoading(buy, true);
      ajaxAdd(id, Math.max(1, parseInt(qty, 10) || 1))
        .then(function () { window.location.href = '/checkout'; })
        .catch(function (err) { setLoading(buy, false); showError(buy, err.message); });
      return;
    }
    var cartLink = e.target.closest('[data-bz-cart-link]');
    if (cartLink && window.Shopify && window.Shopify.actions && window.Shopify.actions.openCart && themeDrawer()) {
      e.preventDefault();
      try { window.Shopify.actions.openCart(); } catch (err) { window.location.href = '/cart'; }
    }
  });

  // Keep the header count in sync with the theme's cart drawer changes
  ['shopify:cart:lines-update', 'cart:update'].forEach(function (evt) {
    document.addEventListener(evt, function () { setTimeout(refreshCount, 600); }, true);
  });

  /* ---------- Collection filters ---------- */
  var filterForm = $('#bz-filter-form');
  if (filterForm) {
    var isDesktop = function () { return window.matchMedia('(min-width: 990px)').matches; };
    var submit = function () {
      // Drop empty price inputs so they don't create blank filters
      $$('input[type="number"]', filterForm).forEach(function (i) { i.disabled = i.value === ''; });
      filterForm.submit();
    };
    filterForm.addEventListener('change', function (e) {
      if (e.target.matches('input[type="checkbox"]') && isDesktop()) submit();
    });
    filterForm.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
    $$('[data-bz-sort]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var hidden = filterForm.querySelector('input[name="sort_by"]');
        hidden.value = sel.value;
        submit();
      });
    });
  }

  /* ---------- Delivery estimate (UK, Mon–Fri, 4pm cut-off) ---------- */
  function londonNow() {
    try {
      var s = new Date().toLocaleString('en-GB', { timeZone: 'Europe/London', hour12: false });
      var m = s.match(/(\d+)\/(\d+)\/(\d+),?\s+(\d+):(\d+):(\d+)/);
      if (m) return new Date(+m[3], +m[2] - 1, +m[1], +m[4], +m[5], +m[6]);
    } catch (e) {}
    return new Date();
  }
  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) n--;
    }
    return d;
  }
  function fmt(d) { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); }
  $$('[data-bz-delivery]').forEach(function (box) {
    var minDays = parseInt(box.getAttribute('data-min') || '7', 10);
    var maxDays = parseInt(box.getAttribute('data-max') || '9', 10);
    var cutoff = parseInt(box.getAttribute('data-cutoff') || '16', 10);
    var now = londonNow();
    var day = now.getDay();
    var isBizDay = day !== 0 && day !== 6;
    var start = new Date(now.getTime());
    if (!isBizDay || now.getHours() >= cutoff) {
      // Next business day becomes "day 0"
      start = addBusinessDays(now, 1);
    }
    var from = addBusinessDays(start, minDays);
    var to = addBusinessDays(start, maxDays);
    var dates = box.querySelector('[data-bz-dates]');
    if (dates) dates.textContent = fmt(from) + ' – ' + fmt(to);
    var timer = box.querySelector('[data-bz-countdown]');
    if (timer) {
      if (isBizDay && now.getHours() < cutoff) {
        var mins = (cutoff * 60) - (now.getHours() * 60 + now.getMinutes());
        var h = Math.floor(mins / 60), m = mins % 60;
        timer.innerHTML = 'Order within <strong>' + (h ? h + 'h ' : '') + m + 'm</strong> for processing today.';
      } else {
        timer.innerHTML = 'Order now — processed <strong>next business day</strong>.';
      }
    }
  });
})();
